
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Plus } from "lucide-react";
import { AvailableRoutinesList } from "./AvailableRoutinesList";

interface AddRoutineButtonProps {
  onClick: (routineId: string, preloadedRoutine?: any) => void;
  planId: string;
}

export const AddRoutineButton = ({ onClick, planId }: AddRoutineButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleRoutineSelect = (routineId: string, preloadedRoutine?: any) => {
    // Cerrar el modal de inmediato y disparar la acción en background
    setOpen(false);
    Promise.resolve()
      .then(() => onClick(routineId, preloadedRoutine))
      .catch((error) => console.error("Error selecting routine:", error));
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
         <Button
          variant="outline"
          className="gap-2 bg-primary/20 hover:bg-primary/40 text-primary"
        >
          <Plus className="h-4 w-4" />
          Agregar rutina
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-card/95 backdrop-blur-xl border-border text-foreground">
        <DialogHeader>
          <DialogTitle className="text-primary">Seleccionar o crear rutina</DialogTitle>
        </DialogHeader>
        <AvailableRoutinesList
          planId={planId}
          onRoutineSelect={handleRoutineSelect}
        />
      </DialogContent>
    </Dialog>
  );
};
